import React, { useState } from 'react';
import { QRCode } from 'react-qr-code';
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";

const GenerateQRCode = () => {
    useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
    const [url, setUrl] = useState("");  // State to store the URL entered by the user
    const [generatedUrl, setGeneratedUrl] = useState("");  // State to store the URL for QR code generation
    const [canvas, setCanvas] = useState(null);  // State to store the canvas element for downloading image

    // Handle URL input change
    const handleInputChange = (event) => {
        setUrl(event.target.value);
    };

    // Handle button click to generate QR code
    const handleGenerateQRCode = () => {
        if (url) {
            setGeneratedUrl(url);  // Set the entered URL to generate the QR code
        } else {
            alert("Please enter a valid URL.");
        }
    };

    // Function to export QR code as an image
    const handleDownloadImage = () => {
        if (canvas) {
            const imageUrl = canvas.toDataURL('image/png'); // Get the image data URL
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = 'qrcode.png'; // Set the download file name
            link.click(); // Trigger download
        }
    };

    return (
        <>
            <Navbar />

            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs /><br />
                        <h2>Generate QR Code for URL</h2>
                        <br />

                        {/* Input field to enter the URL */}
                        <input
                            type="text"
                            value={url}
                            onChange={handleInputChange}
                            placeholder="Enter a URL"
                            className="url-input"
                        />

                        {/* Button to trigger QR code generation */}
                        <button onClick={handleGenerateQRCode} className="generate-button">
                            Generate QR Code
                        </button>
                        <br />

                        {/* Display the QR code if generatedUrl is not empty */}
                        {generatedUrl && (
                            <div>
                                {/* The QR code will be drawn into the canvas */}
                                <QRCode
                                    value={generatedUrl}
                                    size={256}
                                    renderAs="canvas"
                                    onRender={(canvasElement) => setCanvas(canvasElement)} // Set the canvas when rendered
                                />
                                <p>Scan the QR code above</p>

                                {/* Button to download the QR code image */}
                                <button onClick={handleDownloadImage} className="download-button">
                                    Download QR Code as Image
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default GenerateQRCode;
